import { SelectOption } from 'components/Select'
import { Alert } from 'features/alerts/types/alert'
import { DomainAlerts } from 'features/inventory/domain'
import { DomainAlert } from 'features/inventory/domain/types/DomainAlert'
import { DomainAmazonOption } from '../../hooks/useGetDomainAmazons'

export const optionsMapper = (options: DomainAmazonOption[]): SelectOption<DomainAmazonOption>[] =>
  options.map((option: DomainAmazonOption): SelectOption<DomainAmazonOption> => {
    const abTestAlert: Alert<DomainAlert> | undefined = option.alerts.find(
      (alert: Alert<DomainAlert>) => alert.name === 'abTestActive',
    )

    return {
      ...option,
      endAdornment: abTestAlert ? <DomainAlerts alerts={[abTestAlert]} /> : undefined,
    }
  })
